var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732789570550,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 40033,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.995431 1024S58.187025 697.102172 58.187025 448.320784v-2.290804A450.830361 450.830361 0 0 1 511.995431 0.010309h2.290805a450.3722 450.3722 0 0 1 451.517602 448.310475c0 248.781388-453.808407 575.679216-453.808407 575.679216z m-123.245291-760.547153h-68.724141v409.137715h68.724141z m251.988514 0h-173.184833v409.137715h68.72414v-156.003798h103.544372c98.504601 0 148.444143-43.754369 148.444143-126.681499s-49.481381-126.452418-147.985983-126.452418zM699.612335 443.510094a110.187705 110.187705 0 0 1-64.142531 14.66115h-98.504602v-137.44828h98.504602a114.540234 114.540234 0 0 1 64.142531 14.66115 52.917588 52.917588 0 0 1 19.471839 54.06299 59.790002 59.790002 0 0 1-19.471839 54.06299z",
    "p-id": 40034,
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIp);
export default __webpack_public_path__ + "static/media/ip.bc415a8b46a63cedb61715c60f318381.svg";
export { ForwardRef as ReactComponent };